/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Plan_FreeInputs */



/**
* | output |
* | --- |
* | "Free" |
*
* @param {Signup_Plan_FreeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_plan_free = /** @type {((inputs?: Signup_Plan_FreeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Plan_FreeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Gratuit")
	if (locale === "de") return /** @type {LocalizedString} */ ("Free")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gratuito")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Free")
	if (locale === "es") return /** @type {LocalizedString} */ ("Gratis")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("免费")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Free")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Free")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Gratuito")
	return /** @type {LocalizedString} */ ("Free")
});